import React from 'react';

export const OurPurchaseProcess: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Initial Contact',
      description: 'Reach out to us through our website, phone, or email. Provide basic information about your garden apartment property including location, number of units, and general condition.',
      timeline: 'Day 1',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'Property Information Review',
      description: 'Share available property details with us including rent rolls, operating statements, recent inspections, and any other documentation you have. Don\'t worry if records are incomplete - we can work with what you have.',
      timeline: 'Days 1-3',
      icon: 'ri-file-list-line'
    },
    {
      number: '03',
      title: 'Property Evaluation',
      description: 'Our team conducts a thorough analysis of your property, reviewing financials, assessing market conditions, and evaluating the physical condition. We may schedule a property walkthrough at your convenience.',
      timeline: 'Days 3-7',
      icon: 'ri-search-eye-line'
    },
    {
      number: '04',
      title: 'Cash Offer Presentation',
      description: 'We present you with a fair, no-obligation cash offer. Our offer letter includes purchase price, proposed closing date, and any contingencies. We\'ll explain our valuation and answer all your questions.',
      timeline: 'Days 7-10',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      number: '05',
      title: 'Offer Acceptance & Contract',
      description: 'If you accept our offer, we\'ll prepare a purchase agreement. You\'ll have time to review with your attorney or advisors. We can accommodate seller financing or other creative structures if desired.',
      timeline: 'Days 10-14',
      icon: 'ri-file-text-line'
    },
    {
      number: '06',
      title: 'Due Diligence Period',
      description: 'We conduct our formal due diligence including property inspections, title review, and lease verification. This period is typically brief since we buy as-is and have experience with garden apartments.',
      timeline: 'Days 14-28',
      icon: 'ri-checkbox-multiple-line'
    },
    {
      number: '07',
      title: 'Closing Preparation',
      description: 'Our team coordinates with title companies, attorneys, and lenders to prepare all closing documents. We handle the heavy lifting while keeping you informed throughout the process.',
      timeline: 'Days 28-35',
      icon: 'ri-file-edit-line'
    },
    {
      number: '08',
      title: 'Closing & Funding',
      description: 'We close on your timeline, whether that\'s 30 days or 90 days from contract. At closing, you receive your funds and are released from all property responsibilities. It\'s that simple.',
      timeline: 'Day 30-90',
      icon: 'ri-key-line'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Our Garden Apartment Purchase Process
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            A straightforward, transparent process designed to make selling your garden apartment property as easy as possible.
          </p>
        </div>

        <div className="mb-16">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/9a202016b0054a1b1d74b676a185673f.jpg"
              alt="Professional Real Estate Closing"
              className="w-full h-[450px] object-cover object-top"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300"
            >
              <div className="flex items-start mb-6">
                <div className="text-6xl font-bold text-orange-500/30 mr-6">
                  {step.number}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-2xl font-bold">
                      {step.title}
                    </h3>
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 ml-4">
                      <i className={`${step.icon} text-xl text-white`}></i>
                    </div>
                  </div>
                  <div className="inline-block px-3 py-1 bg-orange-500/20 rounded-full text-sm font-semibold text-orange-300 mb-4">
                    {step.timeline}
                  </div>
                  <p className="text-gray-300 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#get-offer"
            className="inline-block px-10 py-5 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl text-lg whitespace-nowrap"
          >
            Start Your Sale Today
          </a>
        </div>
      </div>
    </section>
  );
};